<template>
  <section class="skuSp-manage">
    <Card>
      <Form ref="searchForm" :model="searchForm" inline :label-width="0">
        <Row>
          <Col span="16">
            <FormItem prop="skuName">
              <Select
                v-model="searchForm.spCode"
                placeholder="请选择服务商"
                class="public-inp"
              >
                <Option value="">全部</Option>
                <Option
                  v-for="item in spInfoQueryAll || []"
                  :key="item.code"
                  :value="item.code"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleSearch"
                type="primary"
                icon="ios-search"
                v-access="'skuAreaManage.query'"
                >搜索</Button
              >
              <Button
                @click="handleReset"
                style="margin-left: 10px"
                v-access="'skuAreaManage.reset'"
                >重置</Button
              >
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleAdd"
                type="error"
                style="margin-left: 10px"
                v-access="'skuAreaManage.add'"
                ><Icon type="md-add" />设置区域主资金商/服务商</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table
        :loading="loading"
        border
        :columns="columns"
        :data="areaMainSp.data"
        ref="table"
      >
        <template slot-scope="{ row }" slot="stype">
          <!-- stype,0-资金商，1-服务商 -->
          <span>{{ row.stype == 1 ? "服务商" : "资金商" }}</span>
        </template>
      </Table>

      <Row type="flex" justify="end" class="page" style="margin-top: 10px">
        <Page
          :total="areaMainSp.total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          size="small"
          show-total
          show-elevator
          show-sizer
        >
        </Page>
      </Row>
    </Card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "skuSpManage",
  data() {
    return {
      total: 0,
      drop: false,
      loading: false,
      dataSource: [],
      brandAllList: [],
      categoryAllList: [],
      baseRetailerTypeList: [],
      statusList: [
        { label: "已发布", value: "01" },
        { label: "已上架", value: "02" },
        { label: "已下架", value: "03" },
        { label: "停用", value: "04" },
      ],
      searchForm: {
        page: 1,
        pageSize: 10,
        spCode: "",
      },
      columns: [
        {
          title: "areaAtpnames",
          key: "areaAtpnames",
        },
        {
          title: "资金商/服务商",
          key: "spCode",
        },
        {
          title: "stype",
          slot: "stype",
        },
        {
          title: "updatetime",
          key: "updatetime",
        },
        {
          title: "操作",
          key: "retCode",
          minWidth: 100,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h(
                "a",
                {
                  directives: [
                    {
                      name: "access",
                      value: "skuAreaManage.delete",
                    },
                  ],
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {},
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      areaMainSp: "shop/getShopAreaMainSp",
      spInfoQueryAll: "merchant/getSpInfoQueryAll",
    }),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getList();

      // 查询资金商&服务商
      this.$store.dispatch("merchant/getSpInfoQueryAll");
    },
    getList() {
      this.$store.dispatch("shop/getShopAreaMainSp", this.searchForm);
    },
    handleSearch() {
      this.getList();
    },
    handleReset() {
      this.searchForm.spCode = "";
      this.getList();
    },
    handleAdd() {
      this.$router.push({
        path: "skuAreaManageSet",
      });
    },
    changePage(v) {
      this.searchForm.page = v;
      this.getList();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getList();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/commodity/skuAreaManage.vue